<template>
  <section class="block">
    <div class="group group--first-last-small">
      <div class="mt2" v-for="(content, index) in sections" :key="index">
        <h3 class="h3 mt0">{{ content.title }}</h3>
        <p
          v-for="(paragraph, index) in content.copy"
          class="p mw-100"
          :key="index"
          v-html="paragraph"
        />
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      sections: [
        {
          title: `Your Dental Work`,
          copy: [
            `Dentists are medical experts in their field, and we pay a lot of money for their knowledge, `+
            `expertise, and experience.  We don’t want to suggest that this is easy nor is it black-and-white. ` +
            `Dentistry involves years of practice and expert judgement.`,
            `However, x-rays are one great way to verify the quality of work a patient has received. ` +
            `Dental organizations (<a class="link link--secondary tdn" ` +
            `href="https://www.aae.org/" target="_blank">AAE</a> and <a class="link link--secondary tdn" ` +
            `href="https://www.ada.org/" target="_blank">ADA</a>) have defined the standards for good dental care. All ` +
            `dental care professionals learned these standards in years of training and education. Your ` +
            `VeriTooth report shines a light on a few key standards as a spot check.`,
          ],
        },
        {
          title: `The Standards`,
          copy: [
            `While dentistry is a great deal more than simple criteria, these are some standard ways ` +
            `dental work can be checked for quality.  If these things were not done or done poorly it ` +
            `can lead to all kinds of future problems including infection, cracked teeth, tooth loss ` +
            `or even greater health risks.`,
            `Expert reviewers took the following standards into consideration when verifying your x-ray:`,
          ],
        },
      ],
    };
  },
};
</script>



// WEBPACK FOOTER //
// Info.vue?9360a9cc